import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import AppSection from './components/AppSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import UpdatesSection from './components/UpdatesSection';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-900">
      <Header />

      <main>
        <HeroSection />
        <CardsSection />
        <FaqSection />
        <AboutSection />
        <RankingSection />
        <CommentsSection />
        <ContactSection />
        <IndexSection />
        <CarouselSection />
        <TopicsSection />
        <AppSection />
        <FeaturesSection />
        <MediaSection />
        <UpdatesSection />
      </main>

      <Footer />
    </div>
  );
}